import { Plus } from "lucide-react";
import { Reveal } from "../components/Reveal";

export function ContactSection({ onContact }) {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="mx-auto max-w-[760px] px-6 py-[112px] sm:px-8 sm:py-[160px]"
    >
      <Reveal className="text-center">
        <p
          data-testid="contact-line"
          className="text-[1.6rem] font-medium leading-[1.35] tracking-[-0.01em] text-[#2C3639] sm:text-[2.4rem]"
        >
          <span className="text-[#A27B5B]">People. Places. Potential.</span>
          <br />
          Let’s talk.
        </p>
        <button
          type="button"
          onClick={onContact}
          data-testid="contact-cta"
          className="group mt-8 inline-flex items-center gap-2 border-b border-[#2C3639] pb-1 text-[1.1rem] tracking-tight text-[#2C3639] transition-colors duration-300 hover:border-[#A27B5B] hover:text-[#A27B5B] sm:text-[1.25rem]"
        >
          Get in touch
          <Plus className="h-4 w-4 text-[#A27B5B] transition-transform duration-300 group-hover:rotate-90" />
        </button>
      </Reveal>
    </section>
  );
}
